<template>
	<h1>
		Тестирование знаний по фронтенду
	</h1>

	<div class="mainWrapper">
		<div class="topMenu">
			<router-link to="/" class="item">Тест</router-link>
			<router-link to="/stats/" class="item">Статистика</router-link>
		</div>
		
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	
};
</script>

<style>
body {
	--main-font-size: 20px;
	font-size: var(--main-font-size);
	margin: 0;
	font-family: sans-serif;
}

h1 {
	text-align: center;
	font-weight: normal;
	font-size: 1.45em;
	margin: 0;
	background-color: #365536;
	padding: 10px;
	color: #ffffff;
}

.mainWrapper {
	display: flex;
	align-items: center;
	flex-direction: column;
	border: 0px solid red;
	box-sizing: border-box;
}

.topMenu {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0.2em 0 0.3em 0;
	max-width: 800px;
	width: 100%;
	box-sizing: border-box;
	border: 0px solid green;
	padding: 0.2em;
}

.topMenu .item {
	margin: 0 5px;
	color: black;
	font-size: 1.3em;
}

code {
	background-color: #fbfbfb;
	border: 1px solid #c7c7c7;
	border-radius: 3px;
	color: black;
	padding: 0px 2px;
	font-family: sans-serif;
}

pre {
	margin: 5px 50px 5px 5px;
	padding: 0px 0px 0px 4px;
	font-family: Arial, 'DejaVu Sans Mono';
	font-size: 18px;
	font-weight: normal;
	color: #002200;
	background-color: #f4f4e0;
	overflow-x: auto;
	-o-tab-size: 4;
	-moz-tab-size: 4;
	tab-size: 4;
}
</style>
